export default __webpack_public_path__ + "static/media/FAQs.f58a7515.png";